import { render } from "./BillingEntityFormNew.vue?vue&type=template&id=56458696"
import script from "./BillingEntityFormNew.vue?vue&type=script&lang=js"
export * from "./BillingEntityFormNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__